import { useState } from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

interface Props {
    children: any;
    label: string;
    keysToRemoveFromFormValues: string[];
    readOnly?: boolean;
}

const CheckboxToShowBox = ({ children, label, keysToRemoveFromFormValues, readOnly = false }: Props) => {
    const [showChildren, setShowChildren] = useState<boolean>(false);
    const { unregister } = useFormContext();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;

        setShowChildren(checked);

        if (!checked) {
            keysToRemoveFromFormValues.forEach((key) => {
                unregister(key);
            });
        }
    };

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 1,
            }}
        >
            {readOnly ? (
                <Typography data-cy='label'>{label}</Typography>
            ) : (
                <FormControlLabel
                    data-cy='checkbox'
                    sx={{ pl: 0.5 }}
                    control={<Checkbox sx={{ mr: 0.5 }} checked={showChildren} onChange={handleChange} />}
                    label={label}
                />
            )}

            {(showChildren || readOnly) && children}
        </Box>
    );
};

export default CheckboxToShowBox;
